import React from 'react';
import './Card.css';

import Image from '../../assets/images/imagemProduto.jpg';

const Cards = props => {
    return (
        <div className="card">
                <img src={Image} alt="imagem do produto"/>
                <div className="card-title">Título do card</div>
                <div className="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec at eros pellentesque, lobortis lorem sodales, semper lacus.</div>
        </div>
    )
};

export default Cards;